import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const link: ThemeUICSSObject = {
  /* PREPEND HERE */
};

export default link;
